import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from '@/backend/axios'

Vue.use(VueAxios, axios)

export default {
}
